import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { computed, ref, onBeforeMount, watch } from "vue";
import gql from "fraql";
import AppShowEventDetailsLine from "@AppShows/AppShowEventDetailsLine.vue";
import AppAutocomplete from "@AppSelects/AppAutocomplete.vue";
import { uniqBy } from "lodash-es";
import { setupSelectedData, getModelIds } from "@AppSelects/input_composable";
import { useQuery } from "@vue/apollo-composable";
import { apolloClient } from "@/plugins/apollo";
import { useAppInputsHelper } from "./input_composable";
export default /*@__PURE__*/ _defineComponent({
    ...{
        name: "AppSelectEvent",
        inheritAttrs: false
    },
    __name: 'AppSelectEvent',
    props: {
        modelValue: {},
        filterInput: { type: Boolean },
        dataTest: { default: "eventCategory" },
        inputProps: { default: () => ({}) },
        classList: { default: undefined },
        ignoreChipStyle: { type: Boolean, default: false },
        serverSortBy: { default: "name" },
        serverSortDesc: { type: Boolean, default: false }
    },
    emits: [
        "update:modelValue",
        "blur",
        "change",
        "click:clear"
    ],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const { inputPropsCleared } = useAppInputsHelper(props);
        const eventSearch = ref(null);
        const initialEventsLoad = ref(false);
        const prevSelectedEvents = ref([]);
        const events = ref([]);
        onBeforeMount(() => {
            fetchEventsData();
        });
        watch(() => props.modelValue, v => {
            if (!v)
                return;
            fetchEventsData(getModelIds(props, v));
        });
        const inputValue = computed({
            get() {
                return props.modelValue;
            },
            set(v) {
                emit("update:modelValue", v);
            }
        });
        const eventSelections = computed(() => {
            return uniqBy([...(prevSelectedEvents.value ?? []), ...(events.value ?? [])], "id");
        });
        const eventFragment = gql `
  fragment _ on Event {
    id
    name
    ${AppShowEventDetailsLine.fragments.event}
  }
`;
        const { loading, onResult } = useQuery(gql `
  query AppSelectEventQuery(
    $offset: Int
    $limit: Int
    $sortBy: String
    $sortDesc: Boolean
    $keyword: String
  ) {
    events(
      offset: $offset
      limit: $limit
      sortBy: $sortBy
      sortDesc: $sortDesc
      keyword: $keyword
    ) {
      ${eventFragment}
    }
  }
`, () => ({
            offset: 0,
            limit: 200,
            sortBy: props.serverSortBy,
            sortDesc: props.serverSortDesc,
            keyword: eventSearch.value
        }), () => ({
            enabled: eventSearch.value?.length >= 3,
            debounce: 750,
            fetchPolicy: "cache-and-network"
        }));
        onResult(({ data, loading }) => {
            if (loading)
                return false;
            events.value = data.events ?? [];
        });
        const menuProps = computed(() => {
            const defaultValues = {
                contentClass: "entsys--item-space"
            };
            return Object.assign(defaultValues, props.inputProps.menuProps ?? {});
        });
        async function fetchEventsData(customIds = []) {
            let eventIds = [...customIds];
            if (customIds.length == 0) {
                eventIds = setupSelectedData(props, prevSelectedEvents);
                if (eventIds.length === 0)
                    return;
            }
            initialEventsLoad.value = true;
            try {
                const { data } = await apolloClient.query({
                    query: gql `
        query AppSelectEventQuerySetup($eventIds: [ID]) {
          events(eventIds: $eventIds) {
            id
            ${eventFragment}
          }
        }
      `,
                    variables: {
                        eventIds
                    },
                    fetchPolicy: "cache-first"
                });
                prevSelectedEvents.value = data.events ?? [];
            }
            catch (error) {
                // nothing
            }
            finally {
                initialEventsLoad.value = false;
            }
        }
        function clearSearch() {
            prevSelectedEvents.value = [];
            eventSearch.value = null;
        }
        return (_ctx, _cache) => {
            const _component_v_list_item_title = _resolveComponent("v-list-item-title");
            const _component_v_list_item_subtitle = _resolveComponent("v-list-item-subtitle");
            const _component_v_list_item = _resolveComponent("v-list-item");
            return (_openBlock(), _createBlock(AppAutocomplete, _mergeProps({
                modelValue: inputValue.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((inputValue).value = $event))
            }, { filterInput: _ctx.filterInput }, {
                search: eventSearch.value,
                "onUpdate:search": _cache[1] || (_cache[1] = ($event) => ((eventSearch).value = $event)),
                "show-tooltip": "",
                "data-test": _ctx.dataTest,
                "input-props": {
                    label: 'Events',
                    items: eventSelections.value,
                    loading: _unref(loading) || initialEventsLoad.value,
                    hideNoData: true,
                    noFilter: true,
                    itemValue: 'id',
                    itemTitle: 'name',
                    hideDetails: true,
                    clearable: true,
                    ..._unref(inputPropsCleared),
                    menuProps: menuProps.value
                },
                "onClick:clear": _cache[2] || (_cache[2] =
                    e => {
                        clearSearch();
                        _ctx.$emit('click:clear', e);
                    }),
                onChange: _cache[3] || (_cache[3] = e => _ctx.$emit('change', e)),
                onBlur: _cache[4] || (_cache[4] = e => _ctx.$emit('blur', e))
            }), {
                item: _withCtx(({ props: itemProps, item }) => [
                    _createVNode(_component_v_list_item, _normalizeProps(_guardReactiveProps(itemProps)), {
                        title: _withCtx(() => [
                            _createVNode(_component_v_list_item_title, null, {
                                default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(item.raw.name), 1)
                                ]),
                                _: 2
                            }, 1024)
                        ]),
                        subtitle: _withCtx(() => [
                            _createVNode(_component_v_list_item_subtitle, null, {
                                default: _withCtx(() => [
                                    _createVNode(AppShowEventDetailsLine, {
                                        event: item.raw
                                    }, null, 8, ["event"])
                                ]),
                                _: 2
                            }, 1024)
                        ]),
                        _: 2
                    }, 1040)
                ]),
                _: 1
            }, 16, ["modelValue", "search", "data-test", "input-props"]));
        };
    }
});
